<template>
  <div id="solution1">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping" id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide-banner" style="background-image: url('https://img.deepbaytech.com/images/AIbanner.png')">
          <div class="swiper-slide-title">
            <div style="font-size: 48px; padding-left: 20px; margin: 0 auto;">一站式解决方案1</div>
            <div style="font-size: 20px; padding-left: 20px; margin: 12px auto 18px auto">云 + 智能
              一站式解决方案，减少流程，提高效率</div>
            <a href="/cooperation" class="service">服务咨询</a>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="solution-container">
        <div class="solution-container-title">行业解决方案</div>
        <div class="solution-tab">
          <ul class="solution-tab-header" id="tabList">
            <li v-for="(solutionTab,index) in solutionTabs" :key="index" :class="{'active-tab1' : isShow==index}" @click="tabHandle(index)">
              {{solutionTab.tabname}}</li>
          </ul>
          <div class="solution-main" id="main">
            <div class="solution-main-c" :class="{'active-main': isShow !== 0}">
              11
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 1}">
              22
            </div>
            <div class="solution-main-c" :class="{'active-main': isShow !== 2}">
              33
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务咨询 -->
    <Consultation />
    <!-- 尾部 -->
    <Footer />
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import Consultation from "./../../components/Consultation/Consultation"
import Footer from "./../../components/Footer/Footer"
export default {
  name: 'Solution1',
  components: {
    Consultation,
    Footer
  },
  data () {
    return {
      active: '',
      isShow: 0,
      solutionTabs: [
        { "tabname": "智慧医疗" },
        { "tabname": "智慧金融" },
        { "tabname": "智能制造" },
        { "tabname": "智慧医疗" },
        { "tabname": "智慧医疗" },
        { "tabname": "智慧金融" },
        { "tabname": "智能制造" },
        { "tabname": "智慧医疗" },
        { "tabname": "智慧医疗" },
        { "tabname": "智慧金融" },
        { "tabname": "智能制造" },
        { "tabname": "智慧医疗" },
        { "tabname": "智慧医疗" },
        { "tabname": "智慧金融" },
        { "tabname": "智能制造" },
        { "tabname": "智慧医疗" }
      ]
    }
  },
  mounted () {
    new Swiper('#banner', {
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  },
  methods: {
    tabHandle (flag) {
      this.isShow = flag
    }
  }
}
</script>
<style scoped>
hr {
  border: none;
  height: 1px;
  background-color: #e5e5e5;
}
li {
  list-style: none;
}
.swiper-container {
  height: 480px;
}
.swiper-slide-banner {
  width: 100%;
  height: 480px !important;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title {
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 170px;
}
.service {
  font-size: 16px;
  margin: 12px auto 18px 20px;
  text-decoration: none;
  display: inline-block;
  width: 140px;
  height: 40px;
  background: #fd6622;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
}
.service:hover {
  background: rgb(248, 86, 10);
}
.container {
  width: 100%;
  min-width: 1180px;
}
.solution-container {
  width: 100%;
}
.solution-container-title {
  width: 1180px;
  font-size: 32px;
  margin: 40px auto 24px auto;
}
.solution-tab-header {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 1180px;
  margin: auto;
}
.solution-tab-header li {
  width: 140px;
  height: 40px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
  border: 1px solid rgba(204, 204, 204, 1);
  border-left: 1px solid rgba(204, 204, 204, 0);
  margin-bottom: 16px;
}
.solution-tab-header li:nth-child(8n + 1) {
  border-left: 1px solid rgb(204, 204, 204, 1);
}
.solution-tab-header li:not(.active-tab1):hover {
  color: #fd6622;
  border: 1px solid #fd6622 !important;
}
.active-tab1 {
  background: #fd6622;
  color: #ffffff;
  border: 1px solid #fd6622 !important;
}
.active-main {
  display: none;
}
.solution-main {
  margin-top: 20px;
  background-color: #f6f8fb;
}
.solution-main-c {
  width: 1180px;
  margin: auto;
}
</style>
